import type { MouseEvent as ReactMouseEvent, ReactNode } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { isModClick, markNextUrlOpenIntent } from '@/lib/open-intent'
import { clearTabClickNavigation } from '@/hooks/use-url-sync'

/**
 * In-app Maater route (Inbox, Todos, settings). Stays in the current Chrome tab.
 * Plain click: url-sync replaces an unpinned tab. Cmd/Ctrl-click or middle-click
 * forces a new in-app tab (ADR-0016).
 */
export function InAppRouteLink({
  to,
  className,
  children,
  ...domProps
}: {
  to: string
  className?: string
  children?: ReactNode
  [key: string]: unknown
}) {
  const navigate = useNavigate()

  const openInApp = (event: ReactMouseEvent, forceNew: boolean) => {
    event.preventDefault()
    event.stopPropagation()
    if (forceNew) markNextUrlOpenIntent('new')
    clearTabClickNavigation()
    navigate(to)
  }

  return (
    <Link
      to={to}
      className={className}
      onClick={(event) => {
        if (event.button !== 0 || event.altKey) return
        openInApp(event, isModClick(event) || event.shiftKey)
      }}
      onAuxClick={(event) => {
        if (event.button === 1) openInApp(event, true)
      }}
      {...domProps}
    >
      {children}
    </Link>
  )
}
